import { FC, ReactElement } from 'react'

import { Page } from '@/components'
import { ConnectedLeaveOfAbsenceDetail } from '@/connectors'

export const AbsenceDetailPage: FC = (): ReactElement => (
    <Page className="absence-detail-page">
        <ConnectedLeaveOfAbsenceDetail />
    </Page>
)
